export const cellphoneValidation = (value) => {
  if (!value) return false
  const digits = value.replace(/\D/g, '')
  return digits.length === 11 && digits[2] === '9'
}

/**
 * Official Serpro conversion table for alphanumeric CNPJ characters
 * (used to calculate CNPJ check digits)
 */

const serproAlphaTable = {
  '0': 0,
  '1': 1,
  '2': 2,
  '3': 3,
  '4': 4,
  '5': 5,
  '6': 6,
  '7': 7,
  '8': 8,
  '9': 9,
  'A': 17,
  'B': 18,
  'C': 19,
  'D': 20,
  'E': 21,
  'F': 22,
  'G': 23,
  'H': 24,
  'I': 25,
  'J': 26,
  'K': 27,
  'L': 28,
  'M': 29,
  'N': 30,
  'O': 31,
  'P': 32,
  'Q': 33,
  'R': 34,
  'S': 35,
  'T': 36,
  'U': 37,
  'V': 38,
  'W': 39,
  'X': 40,
  'Y': 41,
  'Z': 42
}

const CNPJ_LENGTH = 14
const CNPJ_BODY_LENGTH = 12
const CNPJ_CHECK_DIGIT_MODULUS = 11
const CNPJ_CHECK_DIGIT_THRESHOLD = 2
const CNPJ_FORMATTING_CHARS_REGEX = /[.\-/]/g
const CNPJ_REPEATED_CHARS_REGEX = /^(\w)\1+$/
const CNPJ_ONLY_LETTERS_AND_NUMBERS_REGEX = /^[0-9A-Z]+$/
const CNPJ_WEIGHTS_12 = [ 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2 ]
const CNPJ_WEIGHTS_13 = [ 6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2 ]

/**
 * Calculate Serpro check digit using CNPJ weighting rules.
 * Accepts the first 12 chars to compute the first check digit or
 * the first 13 chars (including first check digit) for the second.
 */
const calculateSerproCheckDigit = (partialCnpj) => {
  const weights = partialCnpj.length === CNPJ_BODY_LENGTH ? CNPJ_WEIGHTS_12 : CNPJ_WEIGHTS_13

  let sum = 0
  Array.from(partialCnpj).forEach((char, i) => {
    const num = serproAlphaTable[char.toUpperCase()]
    if (num === undefined) return 0
    sum += num * weights[i]
  })

  const remainder = sum % CNPJ_CHECK_DIGIT_MODULUS
  return remainder < CNPJ_CHECK_DIGIT_THRESHOLD ? 0 : CNPJ_CHECK_DIGIT_MODULUS - remainder
}

/**
 * Validate alphanumeric CNPJ using Serpro table
 */
export const isCNPJ = (value) => {
  if (!value || typeof value !== 'string') return false

  const cleanedString = value.replace(CNPJ_FORMATTING_CHARS_REGEX, '').toUpperCase()

  if (cleanedString.length !== CNPJ_LENGTH) return false

  if (!CNPJ_ONLY_LETTERS_AND_NUMBERS_REGEX.test(cleanedString)) return false

  const hasRepeatedChars = CNPJ_REPEATED_CHARS_REGEX.test(cleanedString)

  if (hasRepeatedChars) return false

  const firstDigit = calculateSerproCheckDigit(cleanedString.slice(0, CNPJ_BODY_LENGTH))
  const secondDigit = calculateSerproCheckDigit(
    cleanedString.slice(0, CNPJ_BODY_LENGTH) + firstDigit)

  return cleanedString.endsWith(`${firstDigit}${secondDigit}`)
}
